export default __webpack_public_path__ + "media/transfer_window/transfer_completed-1-8f965ee1.gif";